
/**
 * Handles the image payload and returns the appropriate value based on its type.
 *
 * @param {string|object|array|null} payload - The payload to handle. It can be a string, an object, an array or null.
 * @returns {string|null} - Returns the payload if it's a string, the first value of the object if it's an object,
 * the highest numeric key in the array if it's an array, otherwise null.
 */
function imagePayloadHandler(payload) {
  if (!payload) return null
  if (typeof payload === 'string') return payload
  if (typeof payload === 'object' && !Array.isArray(payload)) return payload[Object.keys(payload)[0]]
  return payload[Math.max(...Object.keys(payload).map(key => parseInt(key)))]
}

export { imagePayloadHandler }